import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import Component from '../components/Projects/index'
import { setProject, fetchProjects } from '../ducks/projects'
import { resetSegments } from '../ducks/segments'

function mapStateToProps(state) {
  return {
    projects: state.projects.list,
    fetched: state.projects.fetched,
    fetching: state.projects.fetching,
    auth: state.auth,
    project: state.projects.selected,
    type: state.types.selected,
    me: state.me,
  }
}

function mapDispatchToProps(dispatch) {
  const actions = {
    resetSegments,
    setProject,
    fetchProjects,
    push,
  }

  return { actions: bindActionCreators(actions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./containers/Projects.js